import React, { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { Images } from "../../../../config/images";
import CustomPasswordInput from "../../../common/CustomPasswordInput";
import useSetParentPassword from "../../../../hooks/parent/useParentSetPassword";

const ParentSetPasswordForm = ({ type }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const inputRef = useRef(null);

  const token = searchParams.get("token");
  const email = searchParams.get("email");

  const { loading, error, setParentPassword } = useSetParentPassword();

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const initialValues = {
    password: "",
    password_confirmation: "",
  };

  const validationSchema = Yup.object({
    password: Yup.string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters")
      .matches(/[A-Z]/, "Must contain an uppercase letter")
      .matches(/[a-z]/, "Must contain a lowercase letter")
      .matches(/[0-9]/, "Must contain a number")
      .matches(/[@$!%*?&^#]/, "Must contain a special character"),
    password_confirmation: Yup.string()
      .oneOf([Yup.ref("password")], "Passwords must match")
      .required("Please confirm your password"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      await setParentPassword({
        email,
        token,
        password: values.password,
        // password_confirmation: values.password_confirmation,
      });

      toast.success("Password set successfully");
      navigate("/"); // Redirect to home page
    } catch (err) {
      if (err.error_code === "TOO_MANY_REQUESTS") {
        toast.error(
          `Too many attempts. Try again after ${Math.ceil(
            err.retry_after / 60,
          )} minutes`,
        );
      } else {
        toast.error(err.message);
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="tenant-login-wrapper">
      <div className="tenant-login-card">
        <div className="tenant-login-logo">
          <img src={Images.Logo} alt="logo" onClick={() => navigate("/")} />
          <p className="tenant-login-title">Set Password</p>
        </div>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form className="d-flex flex-column gap-3">
              <CustomPasswordInput
                label="Password"
                name="password"
                placeholder="Enter your password"
                ref={inputRef}
              />

              <CustomPasswordInput
                label="Confirm Password"
                name="password_confirmation"
                placeholder="Confirm your password"
              />

              {error && <div className="custom-error text-center">{error}</div>}

              <button
                type="submit"
                className="custom-primary-button"
                disabled={loading || isSubmitting}
              >
                {loading ? "Submitting..." : "Submit"}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </section>
  );
};

export default ParentSetPasswordForm;
